import { useEffect, useState } from "react";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/feature/EmptyState";
import NewsCard from "@/components/feature/NewsCard";
import { newsCategories } from "@/mocks/news";
import { getSortedNews } from "@/utils/comic";

export default function NewsListPage() {
  const [active, setActive] = useState("全部");
  const [visible, setVisible] = useState(6);

  const all = getSortedNews();
  const filtered =
    active === "全部" ? all : all.filter((item) => item.category === active);

  useEffect(() => {
    setVisible(6);
  }, [active]);

  return (
    <div className="w-full">
      <section className="w-full px-4 md:px-6 pt-24 md:pt-28 pb-8 bg-background-100">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "动漫资讯" }]} />
        <div className="mt-5 flex items-center gap-4">
          <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-accent-500">
            <i className="ri-newspaper-line text-2xl text-accent-950"></i>
          </span>
          <div>
            <h1 className="text-2xl md:text-3xl font-label font-bold text-foreground-950">
              动漫资讯
            </h1>
            <p className="text-sm text-foreground-600 mt-1">
              新番速递、行业动态、活动公告与作者访谈，一站看全
            </p>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-8">
        <div className="flex flex-wrap items-center gap-2 mb-6">
          {newsCategories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setActive(cat)}
              className={`px-4 py-2 rounded-full text-xs md:text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                active === cat
                  ? "bg-primary-500 text-background-50 font-bold"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <EmptyState
            icon="ri-file-search-line"
            title="当前无相关资讯"
            description="该分类下暂时还没有内容，切换其他分类看看吧。"
            action={
              <button
                type="button"
                onClick={() => setActive("全部")}
                className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-label font-bold cursor-pointer"
              >
                查看全部资讯
              </button>
            }
          />
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {filtered.slice(0, visible).map((item) => (
                <NewsCard key={item.id} news={item} variant="grid" />
              ))}
            </div>
            {visible < filtered.length && (
              <div className="mt-8 flex justify-center">
                <button
                  type="button"
                  onClick={() => setVisible((v) => v + 6)}
                  className="inline-flex items-center gap-2 h-11 px-8 rounded-md border border-background-300 text-foreground-800 text-sm font-label font-bold hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-add-circle-line"></i>
                  加载更多（剩余 {filtered.length - visible} 条）
                </button>
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
}